import { Fragment, useCallback, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { activeLcd } from "../../actions";
import { IReduxStateData } from "../../interfaces/redux";
import { PROFILE_MYCARDS } from "../../constant/menuAndProfile";
import { BASEBALL_TEAM_STATISTICS } from "../../constant/match";
import { Redirect } from "react-router-dom";
import { FaPoll } from "react-icons/fa";

export const LcdList = (props: any) => {
  const dispatch = useDispatch();
  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLanguage = globalState?.selectedLang;
  const [redirectUrl, setRedirectUrl] = useState("");
  const changeActiveLcd = useCallback(
    (value) => {
      //need to improve this
      localStorage.removeItem("dealVideoDisplayed");
      dispatch(activeLcd({ activeLcdIdentifier: value }));
    },
    // eslint-disable-next-line
    [dispatch]
  );
  const getNameFItemsList = (detailObj: any) => {
    return detailObj?.match_title || "";
  };
  const getSubNameFItemsList = (detailObj: any) => {
    return detailObj?.tp_name || "";
  };
  const getImageFItemsList = (detailObj: any) => {
    console.log("detailObj >", detailObj);
    return detailObj?.deal_image || "/assets/images/player-banner.png";
  };
  const isFullScreen = props?.displayFull || false;
  return (
    <Fragment>
      {redirectUrl ? <Redirect to={redirectUrl} /> : null}
      <div className="right-side-header-main d-flex justify-content-between align-items-center">
        <div className="right-side-header">
          {PROFILE_MYCARDS[selectedLanguage].cards}
        </div>
        <Button
          type="button"
          className="font-semibold btn btn-save d-inline px-2 rounded mr-2"
          onClick={() => {
            if (
              globalState?.lcdData?.length &&
              globalState?.activeLcdIndex !== -1
            ) {
              const activeLcdDetail =
                globalState?.lcdData?.[globalState?.activeLcdIndex];
              if (
                activeLcdDetail?.is_player == 2 ||
                activeLcdDetail?.is_player == 4
              ) {
                setRedirectUrl("/teams");
              } else if (activeLcdDetail?.is_player == 3) {
                setRedirectUrl("/players");
              } else {
                setRedirectUrl(`/player/${activeLcdDetail?.tp_identifier}`);
              }
            }
          }}
        >
          {PROFILE_MYCARDS[selectedLanguage]["statistics"]} <FaPoll />
        </Button>
      </div>
      <hr />
      <div>
        <Row>
          {globalState.lcdData &&
          globalState.lcdData.length &&
          globalState.activeLcdIndex !== -1 ? (
            <Fragment>
              {globalState?.lcdData?.map((lcdDetail, index) =>
                index % 2 === 0 ? (
                  <Col
                    xs={12}
                    md={isFullScreen ? 5 : 6}
                    xl={isFullScreen ? 3 : 4}
                    xxl={isFullScreen ? 3 : 4}
                    className="px-5 px-md-0 pl-0 pr-0"
                    onClick={() => {
                      changeActiveLcd(lcdDetail.alphacode_identifier);
                    }}
                  >
                    <div
                      className={`card-column theme-background-green ${
                        globalState.activeLcdIndex === index ? "active" : ""
                      }`}
                    >
                      <img
                        className="card-img theme-background-dark-green py-4 px-2"
                        alt=""
                        src={getImageFItemsList(lcdDetail)}
                      />
                      <div className="card-image-overlay">
                        <div>
                          <span className="image-wrapper">
                            <img
                              className="image-rank"
                              alt=""
                              src="/assets/images/team-rank.svg"
                            />
                            <span className="image-rank-number">
                              {index + 1}
                            </span>
                          </span>
                          {getNameFItemsList(lcdDetail) ? (
                            <span className="image-team-wrapper">
                              <img
                                alt=""
                                className="team-name"
                                src="/assets/images/team-name.svg"
                              />
                              <span className="team-name-title theme-white-imp text-uppercase line-clamp-1">
                                {getNameFItemsList(lcdDetail)}
                              </span>
                            </span>
                          ) : null}
                        </div>
                        {getSubNameFItemsList(lcdDetail) ? (
                          <div className="image-card-title">
                            {/* ${!lcdDetail.is_player || (lcdDetail.is_player && !lcdDetail.player_jersey_number) ? 'bottom' : ''} */}
                            <span className={`image-card-wrapper bottom`}>
                              <img
                                alt=""
                                className="image-title"
                                src="/assets/images/team-name.svg"
                              />
                              <span className="image-title-name theme-white-imp text-uppercase line-clamp-1">
                                {getSubNameFItemsList(lcdDetail)}
                              </span>
                            </span>
                            {/* {lcdDetail.is_player && lcdDetail.player_jersey_number ?
                                                        <span className='image-circle-wrapper'>
                                                            <img alt='' src='/assets/images/circle.svg' className='image-circle' />
                                                            <span className='circle'>{lcdDetail.player_jersey_number}</span>
                                                        </span>
                                                        : null} */}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </Col>
                ) : (
                  <Col
                    xs={12}
                    md={isFullScreen ? 5 : 6}
                    xl={isFullScreen ? 3 : 4}
                    xxl={isFullScreen ? 3 : 4}
                    onClick={() => {
                      changeActiveLcd(lcdDetail.alphacode_identifier);
                    }}
                    className="px-5 px-md-0 pl-0 pr-0"
                  >
                    <div
                      className={`card-column theme-background-dark-black ${
                        globalState.activeLcdIndex === index ? "active" : ""
                      }`}
                    >
                      <img
                        className="card-img theme-dark-gray py-4 px-2"
                        alt=""
                        src={getImageFItemsList(lcdDetail)}
                      />
                      <div className="card-image-overlay">
                        <div>
                          <span className="image-wrapper">
                            <img
                              className="image-rank"
                              alt=""
                              src="/assets/images/team-rank-green.svg"
                            />
                            <span className="image-rank-number theme-white-imp">
                              {index + 1}
                            </span>
                          </span>
                          {getNameFItemsList(lcdDetail) ? (
                            <span className="image-team-wrapper">
                              <img
                                alt=""
                                className="team-name"
                                src="/assets/images/team-name-green.svg"
                              />
                              <span className="team-name-title theme-dark-black text-uppercase">
                                {getNameFItemsList(lcdDetail)}
                              </span>
                            </span>
                          ) : null}
                        </div>
                        {getSubNameFItemsList(lcdDetail) ? (
                          <div className="image-card-title">
                            {/* ${!lcdDetail.is_player || (lcdDetail.is_player && !lcdDetail.player_jersey_number) ? 'bottom' : ''} */}
                            <span className={`image-card-wrapper bottom`}>
                              <img
                                alt=""
                                className="image-title"
                                src="/assets/images/team-name-green.svg"
                              />
                              <span className="image-title-name theme-dark-black text-uppercase line-clamp-1">
                                {getSubNameFItemsList(lcdDetail)}
                              </span>
                            </span>
                            {/* {lcdDetail.is_player ?
                                                        <span className=' image-circle-wrapper'>
                                                            <img alt='' src='/assets/images/circle-reverse.svg' className='image-circle' />
                                                            <span className='circle circle-reverse  theme-white'>{lcdDetail.player_jersey_number}</span>
                                                        </span>
                                                        : null} */}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </Col>
                )
              )}
            </Fragment>
          ) : null}
        </Row>
      </div>
    </Fragment>
  );
};
